import { CitationDisplay } from "../enums/citation-display.enum";

export const CITATION_DISPLAY_LABELS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Hidden",
    [CitationDisplay.fileOnly]: "Name only",
    [CitationDisplay.pagesInfo]: "Pages (info)",
    [CitationDisplay.pagesLinked]: "Pages (linked)"
};

export const CITATION_DISPLAY_DESCRIPTIONS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Not shown in answers",
    [CitationDisplay.fileOnly]: "File name, no pages",
    [CitationDisplay.pagesInfo]: "Page numbers, not clickable",
    [CitationDisplay.pagesLinked]: "Page numbers open the file"
};

export const CITATION_DISPLAY_ORDER: CitationDisplay[] = [
    CitationDisplay.hidden,
    CitationDisplay.fileOnly,
    CitationDisplay.pagesInfo,
    CitationDisplay.pagesLinked
];
